import { L10n, loadCldr, registerLicense, setCulture, setCurrencyCode } from '@syncfusion/ej2-base'
import loc_de01 from 'cldr-data/main/de/numbers.json'
import loc_de02 from 'cldr-data/main/de/timeZoneNames.json'
import loc_de03 from 'cldr-data/main/de/localeDisplayNames.json'
import loc_de04 from 'cldr-data/main/de/ca-gregorian.json'
import loc_de05 from 'cldr-data/main/de/currencies.json'
import loc_de06 from 'cldr-data/supplemental/currencyData.json'
import loc_de07 from 'cldr-data/supplemental/numberingSystems.json'
import loc_de08 from 'cldr-data/main/de/dateFields.json'
import loc_de09 from 'cldr-data/main/de/delimiters.json'
import loc_de10 from 'cldr-data/main/de/languages.json'
import loc_de11 from 'cldr-data/main/de/listPatterns.json'
import loc_de12 from 'cldr-data/main/de/measurementSystemNames.json'
import loc_de13 from 'cldr-data/main/de/posix.json'
import loc_de14 from 'cldr-data/main/de/scripts.json'
import loc_de15 from 'cldr-data/main/de/territories.json'
import loc_de16 from 'cldr-data/main/de/units.json'
import loc_de17 from 'cldr-data/main/de/variants.json'
import * as sfL18n_de from '@/config/sf/ej2-locale_src_de.json'

//community license created at 2024/06/14 by RS -- valid for version 26.1.X (maybe higher)
const SFKEY = 'Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfdHRSRWVeUkZ0XEI='

export function syncfusionSetup() {
  loadCldr(loc_de01, loc_de02, loc_de03, loc_de04, loc_de05, loc_de06, loc_de07, loc_de08, loc_de09, loc_de10, loc_de11, loc_de12, loc_de13, loc_de14, loc_de15, loc_de16, loc_de17)
  setCulture('de')
  setCurrencyCode('EUR')
  registerLicense(SFKEY)
  L10n.load(sfL18n_de)
}
